
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBatteryPack25 as ObiBatteryPack25Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-battery-pack-25.js';
 
 
 

 
 export const ObiBatteryPack25 = createComponent({
   react: React,
   tagName: 'obi-battery-pack-25',
   elementClass: ObiBatteryPack25Element,
   events: {
     
   }
  });
 
 